import { pipe } from 'ramda';

import { IRootState } from '../root.types';

const pathToGlobalSettingsState = (state: IRootState) => state.globalSettings;

export const getIsSegmentLoaded = pipe(pathToGlobalSettingsState, state => state.isSegmentLoaded);

export const getIsSegmentInit = pipe(pathToGlobalSettingsState, state => state.isSegmentInit);
